'use client';

import { useEffect, useState } from 'react';

import { useIntersectionObserver } from '@/hooks/use-intersection-observer';

type AnimatedTextProps = {
  text: string;
  className?: string;
  delay?: number;
  speed?: number;
};

export function AnimatedText({
  text,
  className = '',
  delay = 0,
  speed = 50,
}: AnimatedTextProps) {
  const [displayedText, setDisplayedText] = useState('');
  const { ref, isIntersecting } = useIntersectionObserver({ threshold: 0.5 });
  useEffect(() => {
    if (!isIntersecting) return;

    const timeout = setTimeout(() => {
      let currentIndex = 0;
      const interval = setInterval(() => {
        if (currentIndex <= text.length) {
          setDisplayedText(text.slice(0, currentIndex));
          currentIndex++;
        } else {
          clearInterval(interval);
        }
      }, speed);

      return () => clearInterval(interval);
    }, delay);

    return () => clearTimeout(timeout);
  }, [isIntersecting, text, delay, speed]);

  return (
    <span ref={ref} className={className}>
      {displayedText}
      <span className="animate-pulse">|</span>
    </span>
  );
}
